// Memória do tour no servidor, por usuário (backend/api/v1/tour).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const tourApi = {
  vistos: () => axios.get(`${API}/tour/vistos`, auth()),
  marcar: (tela, estado) => axios.put(`${API}/tour/vistos/${encodeURIComponent(tela)}`, { estado }, auth()),
};
